// Re-exports depuis la source unique de vérité : src/utils/fiscal.ts
// Ce fichier maintient la compatibilité avec les imports existants dans les composants.
import {
  TAUX_TOTAL_MICRO_CIPAV,
  ABATTEMENT_MICRO_BNC,
  SEUIL_MICRO_BNC,
  SEUIL_TVA_FRANCHISE,
  calculCotisationsTotal_micro,
  calculBeneficeMicro,
  calculIR,
  calculURSSAF_bnc,
  calculRevenuNetMicro,
  calculRevenüNet_bnc,
  calculEconomieBNC,
  calculProvisionSociale,
  calculProvisionFiscale,
  verifierSeuilTVA,
  verifierSeuilMicroBNC,
  DISCLAIMER_ARAPL,
  DISCLAIMER_EXPERT,
} from '@/utils/fiscal'

// Aliases utilisés par Simulateur, Projection, ProgressionAnnuelle
export const TAUX_URSSAF = TAUX_TOTAL_MICRO_CIPAV
export const TAUX_ABATTEMENT_MICRO_BNC = ABATTEMENT_MICRO_BNC
export { SEUIL_MICRO_BNC, SEUIL_TVA_FRANCHISE, DISCLAIMER_ARAPL, DISCLAIMER_EXPERT }
export const SEUIL_TVA = SEUIL_TVA_FRANCHISE

export const calculerURSSAF = calculCotisationsTotal_micro
export const calculerBaseImposableMicroBNC = (ca: number) =>
  Math.round(ca * (1 - ABATTEMENT_MICRO_BNC) * 100) / 100
export const calculerAbattementMicroBNC = (ca: number) =>
  Math.round(ca * ABATTEMENT_MICRO_BNC * 100) / 100
export const calculerIRProgressif = calculIR
export const calculerRevenueNetMicroBNC = calculRevenuNetMicro
export const calculerEconomieBNCClassique = calculEconomieBNC
export const calculerProvisionSociale = calculProvisionSociale
export const calculerProvisionFiscale = calculProvisionFiscale
export const calculerTauxHoraireNet = (ca: number, seances: number, dureeH = 1) => {
  if (seances <= 0) return 0
  const net = calculRevenuNetMicro(ca)
  return Math.round((net / (seances * dureeH)) * 100) / 100
}
export { verifierSeuilTVA, verifierSeuilMicroBNC }
